export const FREQUENCY = ['daily', 'weekly', 'monthly']
export const SETTING_TYPE = {
	job_rating: 'job_rating',
	job_cancellation: 'job_cancellation',
	timecard_submission: 'timecard_submission',
	job_matches: 'job_matches',
	credential_incompleted: 'credential_incompleted',
}
